<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Income Type" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-income-type-form [incomeType]="incomeType" *ngIf="incomeType"></app-income-type-form>
        </form>
      </div>
    </section>
  </div>
</div>


